import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';
import { NoteModel } from './note';
import { parseLocationName } from './base/util';

@MemoizeGetters
export class AddressModel extends BaseEntity {
  id?: number;
  name?: string;
  locationName?: string;
  lat?: number;
  lng?: number;
  zipCode: string;
  zipCodeActive?: boolean;

  street?: string;
  city?: string;
  state?: string;
  country?: string;
  nickname?: string;

  verified?: boolean;
  addressType?: string;
  parkingLotSize?: string;
  parkingLotType?: string;

  @Transform(toEntity(NoteModel))
  notes?: NoteModel[];

  get details() {
    return parseLocationName(this.locationName);
  }

  get regionName(): RegionName {
    if (this.isLA()) {
      return RegionName.LA;
    } else {
      return RegionName.Unknown;
    }
  }

  private isLA() {
    const center = new google.maps.LatLng(34.038155, -118.274114);
    const radius = 1609 * 50;
    const addressLatLng = new google.maps.LatLng(this.lat, this.lng);
    const distance = google.maps.geometry.spherical.computeDistanceBetween(
      addressLatLng,
      center
    );
    return distance < radius;
  }

  get infoComplete() {
    return (
      (this.addressType && this.parkingLotSize && this.parkingLotType) !== null
    );
  }
}

export interface AddressUpdateParams {
  addressType?: string;
  parkingLotSize?: string;
  parkingLotType?: string;
}

export enum RegionName {
  LA = 'Los Angeles',
  Unknown = 'Unknown',
}



// WEBPACK FOOTER //
// ./src/models/address.ts